<template>
  <div>
    <Mainlayout></Mainlayout>

    <CCard class="custom-card h-100 mt-5">
      <br /><br />
      <br />

      <CContainer>
        <CCol sm="12" lg="12" class="custom-margin mt-5">
          <br />
          <h3 class="m-0">Report Card</h3>
          <br />
          <!-- card subjects -->
          <CCard body-wrapper text-color="black" class="custom-card-shadow">
            <div>
              <h4 class="ml-2 mr-2 mb-2 custom-gradient">
                Subject : Additional Mathematic
              </h4>
              <CRow>
                <div class="col-6">
                  <h6 class="ml-2 mr-2 mb-3 text-muted">Grade : FORM 2</h6>
                </div>
                <div class="col-6">
                  <CButton
                    type="submit"
                    color="primary"
                    class="p-2 float-right"
                    size="sm"
                    >View Details</CButton
                  >
                </div>
              </CRow>
            </div>
            <hr />
            <CRow>
              <div class="col-4 text-center border-right">
                <span
                  ><h1 class="mt-2 custom-gradient">80%</h1>
                  Score</span
                >
              </div>
              <div class="col-4 text-center border-right">
                <span
                  ><h1 class="mt-2 custom-gradient">A</h1>
                  Grade</span
                >
              </div>
              <div class="col-4 text-center">
                <span
                  ><h1 class="mt-2 custom-gradient">3</h1>
                  Question</span
                >
              </div>
            </CRow>
          </CCard>

          <CCard body-wrapper text-color="black" class="custom-card-shadow">
            <div>
              <h4 class="ml-2 mr-2 mb-2 custom-gradient">
                Subject : Mathematic
              </h4>
              <CRow>
                <div class="col-6">
                  <h6 class="ml-2 mr-2 mb-3 text-muted">Grade : FORM 2</h6>
                </div>
                <div class="col-6">
                  <CButton
                    type="submit"
                    color="primary"
                    class="p-2 float-right"
                    size="sm"
                    >View Details</CButton
                  >
                </div>
              </CRow>
            </div>
            <hr />
            <CRow>
              <div class="col-4 text-center border-right">
                <span
                  ><h1 class="mt-2 custom-gradient">70%</h1>
                  Score</span
                >
              </div>
              <div class="col-4 text-center border-right">
                <span
                  ><h1 class="mt-2 custom-gradient">A</h1>
                  Grade</span
                >
              </div>
              <div class="col-4 text-center">
                <span
                  ><h1 class="mt-2 custom-gradient">2</h1>
                  Question</span
                >
              </div>
            </CRow>
          </CCard>
        </CCol>
      </CContainer>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import Mainlayout from "../containers/TheHeaderStudentCustom.vue";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout
  },
  data() {
    return {
      backgroundBanner,
      questionDetail: {},
      SubmittedForm: false,
      answer: "",
      Error: false
    };
  },
  async mounted() {
    this.GetQuestion();
  },
  computed: {
    isDisabled: function() {
      return !this.SelectedSubject.Id || !this.SelectedGrade.Id;
    }
  },
  methods: {
    //Get question
    async GetQuestion() {
      return this.$API
        .get(
          this.$QuizQuestion +
            "?quizId=" +
            this.$route.query.quizId +
            "&studentId=" +
            this.$route.query.studentId +
            "&startId=" +
            this.$route.query.startId
        )
        .then(
          function(response) {
            this.questionDetail = response.data;
            if (this.questionDetail == "empty") {
              this.GoToPageScore();
            }
          }.bind(this)
        )
        .catch(function(error) {
          console.log(error.response);
        });
    },

    GoToRefresh() {
      window.location.reload();
    },
    GoToPageScore() {
      this.$router.push(
        "/QuizStudentDashboard?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    }
  }
};
</script>

